    export interface DisruptionTypeModel {
        disruptionType: string;
        disruptionId: number;     
    }

    export const DEFAULT_DISRUPTION_TYPE_MODEL: DisruptionTypeModel = {
        disruptionType: '',
        disruptionId: 0,
    };